// Init "Login"
if (document.getElementById('login-page')) require('./login/login').init();

// Init create account
if (
  (document.getElementById('js-create-account-form') && document.getElementById('js-sport-data')) ||
  (document.getElementById('js-complete-account-form') && document.getElementById('js-sport-data'))
) require('./create-account/create-account-sport').init();



// WEBPACK FOOTER //
// ./src/modules-es5/authentication/index.js